import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EBaseUrl } from "../models/enums/env.enum";
import { api } from "../utils";

const initialState: any = {
  paymentOrderData: {},
  paymentInfoData: {},
};

const name = "Payment";

export const getAmeriaPaymentOrder = createAsyncThunk(
  `${name}/getAmeriaPaymentOrder`,
  async ({
    order,
    language = "am",
    description = "",
  }: {
    order: string;
    language: string;
    description: string;
  }) => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/Ameria?hash=${EBaseUrl.envHash}&order=${order}&language=${language}&description=${description}`,
    });
  }
);

export const getAmeriaPaymentInfo = createAsyncThunk(
  `${name}/getAmeriaPaymentInfo`,
  async ({ order, paymentID }: { order: string; paymentID: string }) => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/Ameria-info?hash=${EBaseUrl.envHash}&order=${order}&paymentID=${paymentID}`,
    });
  }
);

export const getIdramPaymentInfo = createAsyncThunk(
  `${name}/getIdramPaymentInfo`,
  async (param: any) => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/Order/idram-status?orderNumber=${param}`,
    });
  }
);

const paymentSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAmeriaPaymentOrder.fulfilled, (state, { payload }) => {
      state.paymentOrderData = payload;
    });
    builder.addCase(getAmeriaPaymentInfo.fulfilled, (state, { payload }) => {
      state.paymentInfoData = payload;
    });
  },
});

export default paymentSlice.reducer;
